import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {ContactOffComponent} from "./page/contact-off.page/contact-off.component";
import {ContactProjectComponent} from "./page/contact-project.page/contact-project.component";
import {ContactWorkersComponent} from "./page/contact-workers.page/contact-workers.component";
import {DataContactPolicyComponent} from "./page/data-protection-policy.page/data-contact-policy.component";
import {Error404Component} from "./page/error-404.page/error-404.component";
import {LegalNoticeComponent} from "./page/legal-notice.page/legal-notice.component";
import {IndexComponent} from "./page/index.page/index.component";

/**
 * Routing module
 */
const routes: Routes = [
  {
    path: "",
    component: IndexComponent
  },
  {
    path: "contacto-hola"
    , component: ContactOffComponent
  },
  {
    path: "contacto-proyecto"
    , component: ContactProjectComponent
  },
  {
    path: "contacto-trabajo",
    component: ContactWorkersComponent
  },
  {
    path: "politica-proteccion-datos",
    component: DataContactPolicyComponent
  },
  {
    path: "404-not-found",
    component: Error404Component
  },
  {
    path: "aviso-legal",
    component: LegalNoticeComponent
  },
  {
    path: '**', component: Error404Component
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      onSameUrlNavigation: "ignore",
      anchorScrolling:'enabled',
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
